import type { SelectOption } from "@models/Order";
import { Center, HStack, Text, VStack } from "@chakra-ui/react";

interface Props {
	rateLevels: SelectOption[];
	selectedKey?: string;
	onChange: (key: string) => void;
	label: string;
	isCentered?: string;
}

const RateItem = ({ rateLevels, onChange, label, isCentered, selectedKey }: Props) => {
	return (
		<VStack gap={2}>
			{label && (
				<Text mb={0} color={"#999999"} fontSize={"15px"} fontWeight={500}>
					{label}
				</Text>
			)}
			<HStack mt={0} gap={2} justify={isCentered ? "center" : "flex-start"}>
				{rateLevels.map((rl) => (
					<Center
						height={"32px"}
						width={"32px"}
						borderRadius={"10px"}
						border={`1px solid ${selectedKey === rl.key ? "accent.500" : "#999999"}`}
						bg={selectedKey === rl.key ? "accent.500" : ""}
						key={rl.key}
						onClick={() => onChange(rl.key)}
						cursor={"pointer"}
						_hover={{ opacity: 0.5 }}
					>
						<Text fontWeight={400} fontSize={"15px"} color={selectedKey === rl.key ? "#FFFFFF" : "#2A2A2A"}>
							{rl.value}
						</Text>
					</Center>
				))}
			</HStack>
		</VStack>
	);
};

export default RateItem;
